<template>
  <div>
    <el-button type="text" @click="dialogVisible = true">立即投递</el-button>

    <el-dialog
  title="上传简历"
  :visible.sync="dialogVisible"
  width="40%">
  <span>功能维护中，请投递邮箱 15309691517@163.com</span>
  <!-- <el-upload
  class="upload-demo"
  drag
  action="https://jsonplaceholder.typicode.com/posts/"
  :file-list="fileList"
  :show-file-list="true"
  :on-change="handleUploadChange"
  :before-upload="beforeUpload"
  :on-success = "successUpload"
  :on-error = "errorUpload"
  multiple>
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">上传文件简历</div>
  <div class="el-upload__tip" slot="tip">点击上传或直接拖拽文件，支持pdf、doc、docx、txt、xls、xlxs等格式</div>
  </el-upload> -->

    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      fileList:[]
    }
  },
  methods: {
    successUpload() {
      this.$message.success('简历上传成功')
      this.fileList = []
      this.dialogVisible = false
    },
    errorUpload() {
      this.$message.error('简历上传失败')
      this.fileList = []
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.'))
      if (fileType.toLowerCase() != '.pdf'&&fileType.toLowerCase() != '.doc'&& fileType.toLowerCase() != '.docx'&&fileType.toLowerCase() != '.txt' && fileType.toLowerCase() != '.xls' &&fileType.toLowerCase() != '.xlxs') {
        this.$message.error('文件必须为pdf、doc、docx、txt、xls、xlxs类型')
        this.fileList = []
        return false
      }
    },
    // 限制文件上传的个数只有一个，获取上传列表的最后一个
    handleUploadChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]] // 这一步，是 展示最后一次选择的文件
      }
    },
  },
}
</script>

<style lang="less" scoped>
.el-button {
  color: #FFFFFF;
  font-size: 0.22rem;
}
.el-dialog {
  border-radius: 0.18rem ;
  font-size: 0.22rem;
  color: #333333;
}
.el-dialog__title {
    font-size: 0.22rem;
    color: #333333;
}
.el-upload__text {
  font-size: 0.16rem;
  line-height: 0.24rem;
  color: #DADFE3;
}
.el-upload__tip {
  font-size: 0.16rem;
  font-weight: 400;
  line-height: 0.24rem;
  color: #666666;
}
</style>
